/**
 * DO NOT MODIFY THIS FILE!
 * It was created by the Reefer icons generator.
 * For updates, please re-run the generator.
 */

import type { SVGProps } from 'react';

import type { IconComponentProps } from '../../icon/icon.types';
import { Icon } from '../icon';

const LinkedIn = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    fill="none"
    className="Icon/LinkedIn"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#0E0E0E"
      d="M6.476 22H2.331V8.64h4.145zM17.028 8.308c4.197 0 4.972 2.767 4.972 6.364V22h-4.142v-6.498c0-1.549-.029-3.54-2.154-3.541-2.156 0-2.488 1.687-2.488 3.43V22H9.075V8.64h3.976v1.826h.055c.553-1.05 1.906-2.158 3.922-2.158M4.404 2a2.407 2.407 0 0 1 0 4.814A2.406 2.406 0 0 1 2 4.407 2.406 2.406 0 0 1 4.404 2"
      className="SVG"
    />
  </svg>
);

export const LinkedInIcon = ({
  size = 'md',
  'data-testid': testId,
  ...props
}: IconComponentProps) => {
  return (
    <Icon
      data-testid={testId || 'linked-in-icon'}
      icon={LinkedIn}
      {...props}
      size={size}
    />
  );
};
